import { Component, forwardRef, OnInit } from '@angular/core';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { AssetDao } from '@app/dao/asset/asset.dao';
import { UserDao } from '@app/dao/user/user.dao';
import { AssetTypeService } from '@app/services/asset-type.service';
import * as _ from 'lodash';
import { BehaviorSubject, combineLatest, Subject } from 'rxjs';
import { PrBankResourcesFormBuilder } from './ea-bank-resources-form.builder';

@Component({
    selector: 'ea-bank-resources-form',
    templateUrl: './ea-bank-resources-form.component.html',
    styleUrls: ['./ea-bank-resources-form.component.scss'],
    providers: [
        {
            provide: PrFormAbstract,
            useExisting: forwardRef(() => EaBankResourcesFormComponent),
        },
    ],
    standalone: false
})
export class EaBankResourcesFormComponent
  extends PrBankResourcesFormBuilder
  implements OnInit
{
  users: any[];
  references: any;
  groupes: any[];
  sources: any[];
  managers: any[];
  doneSubject: Subject<void> = new Subject<void>();
  tabChanged: BehaviorSubject<any> = new BehaviorSubject(null);
  changeTab: BehaviorSubject<any> = new BehaviorSubject(null);

  products = this.assetTypeService.getBankingAssetTypeOptions();

  constructor(
    protected formConstructor: PrFormConstructor,
    protected assetTypeService: AssetTypeService,
    private userDao: UserDao,
    private assetDao: AssetDao,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    combineLatest([
      this.userDao.getCouple(),
      this.assetDao.getReferences(),
      this.assetDao.getProviderByType(
        this.entity.productType === 'bank-resources'
          ? this.entity.type
          : this.entity.productType,
      ),
    ]).subscribe(([users, references, managers]) => {
      this.users = users;
      this.references = references;
      this.sources = references[0];
      this.managers = managers;
      this.form
        .get('managerProviderId')
        .setValue(
          _.find(this.managers, m => m.id === this.entity.managerProviderId),
        );
      if (this.entity.owners && this.entity.owners.length > 0)
        this.form.get('owners').setValue(this.buildInitialOwners(this.entity));
      if (this.entity.type != null) {
        this.form.controls.productType.setValue(this.entity.type);
      }
    });
  }

  get title() {
    let type =
      this.entity && this.entity.type
        ? this.entity.type.toLocaleLowerCase()
        : '';
    switch (type) {
      case 'COMPTE_COURANT':
        return this.generateTitle(
          'Modifier le placement',
          'Ajout d’un compte courant',
        );
      case 'LDD':
        return this.generateTitle('Modifier le placement', 'Ajout d’un LDD');
      case 'PEL':
        return this.generateTitle('Modifier le placement', 'Ajout d’un PEL');
      case 'CEL':
        return this.generateTitle('Modifier le placement', 'Ajout d’un CEL');
      case 'LIVRET_A':
        return this.generateTitle(
          'Modifier le placement',
          'Ajout d’un livret A',
        );
      case 'CODEVI':
        return this.generateTitle('Modifier le placement', 'Ajout d’un CODEVI');
      case 'LIVRET':
        return this.generateTitle('Modifier le placement', 'Ajout d’un livret');
      case 'SOCIAL_SHARE':
        return this.generateTitle(
          'Modifier le placement',
          'Ajout de parts sociales',
        );
      default:
        return this.generateTitle(
          'Modifier le placement',
          'Ajouter un placement',
        );
    }
  }

  generateTitle(editTitle: string, addTitle: string) {
    if (!this.entity || !this.entity.id) return addTitle;
    if (!this.entity.label || this.entity.label === '') return editTitle;
    return `${editTitle} “${this.entity.label}”`;
  }

  ///REFACTO
  selectProductType(productType) {
    this.form.controls.productType.setValue(productType);
    this.form.updateValueAndValidity();
    this.assetDao.getProviderByType(productType).subscribe(res => {
      this.managers = res;
    });
  }

  onSubmit() {
    this.displayErrors();

    this.selectErrorInput();

    if (this.form.invalid) {
      this.changeTab.next('FIRST');
      return;
    }

    //Fetch every form controls value
    let formDTOExtraction = this.extract();
    this.prFormService.loading();

    this.assetDao;
    /* .proposeManagerProvider(formDTOExtraction, this.managers)
      .pipe(switchMap(() => */ this.assetDao
      .saveAssets(formDTOExtraction)
      .subscribe(
        success => {
          this.prFormService.loaded();
          this.doneSubject.next();
          this.notificationService.success('La sauvegarde a réussi');
        },
        errors => {
          console.error(errors);
          this.prFormService.loaded();
          this.notificationService.error('La sauvegarde a échoué');
        },
      );
  }

  onCancel() {
    this.prFormService.close();
  }

  onTabChange(isLastTab: boolean) {
    this.tabChanged.next(isLastTab);
  }

  nextTab() {
    this.changeTab.next('NEXT');
  }
}
